const DATAENTRY_LIB_CODE = "ynf-lib-base-mobile";
const APCOM_LIB_CODE = "ynf-fw-apcom-mobile-lib";
const REFER_LIB_CODE = "ynf-fw-apcom-mobile-lib";

export const mobileLibCodeMap = {
  input: {
    controlType: "Input",
    libCode: DATAENTRY_LIB_CODE,
  },
  inputrange:{
    controlType: "RangeValue",
    libCode: DATAENTRY_LIB_CODE,
    type: "input"
  },
  datetimepicker: {
    controlType: "DateTimePicker",
    libCode: DATAENTRY_LIB_CODE,
    showTime: true,
  },
  datepicker: {
    controlType: "DatePicker",
    libCode: DATAENTRY_LIB_CODE,
  },
  timepicker: {
    controlType: "TimePicker",
    libCode: DATAENTRY_LIB_CODE,
  },
  inputnumber: {
    controlType: "InputNumber",
    libCode: DATAENTRY_LIB_CODE,
    subuitype: 'decimal'
  },
  booleanoption: {
    controlType: "Enumerate",
    libCode: DATAENTRY_LIB_CODE,
  },
  optionwidget: {
    controlType: "Enumerate",
    libCode: DATAENTRY_LIB_CODE,
  },
  listrefer: {
    controlType: "ReferInput",
    libCode: REFER_LIB_CODE,
  },
  refer: {
    controlType: "ReferInput",
    libCode: REFER_LIB_CODE,
  },
  inputphone: {
    controlType: "Mobile",
    libCode: DATAENTRY_LIB_CODE,
    subuitype: "cell"
  },
  filelist: {
    controlType: "Upload",
    libCode: APCOM_LIB_CODE,
    bizType: "attachment",
    pageStore: "mobx://rootStore.pageStore"
  },
  imagelist: {
    controlType: "PictureUpload",
    fileType: 6,
    libCode: APCOM_LIB_CODE,
    bizType: "image",
    pageStore: "mobx://rootStore.pageStore"
  },
  link: {
    controlType: "Link",
    libCode: DATAENTRY_LIB_CODE,
  },
  inputemail: {
    controlType: "InputEmail",
    libCode: DATAENTRY_LIB_CODE,
  }
};

